<app-subsection-title key="provider.tender.projectDescription.title" />

<div class="card bg-third-level">
  @if (tenderDetails().beginningText) {
    <div [innerHTML]="tenderDetails().beginningText"></div>
  }

  @if (tenderDetails().endText) {
    <br />
    <div [innerHTML]="tenderDetails().endText"></div>
  }

  @if (!tenderDetails().beginningText && !tenderDetails().endText) {
    <p class="text-sm">
      {{ 'provider.tender.projectDescription.noData' | transloco }}
    </p>
  }
</div>
